import { tns } from 'tiny-slider'

export function setupContentSlider(wrapper) {

    const container = wrapper.querySelector('.content-slider-items');
    const controlsContainer = wrapper.querySelector('.content-slider__controls')

    if (!container) {
        throw 'container is required for the slider to function correctly.'
    }

    const style = getComputedStyle(document.body)

    tns({
        container,
        gutter: parseInt(style.getPropertyValue('--grid-gap')),
        controlsContainer,
        nav: false,
    })
}


export function setupContentSliders() {

    const containers = document.querySelectorAll('.content-slider__slider-wrapper')

    containers.forEach(setupContentSlider)

}
